import Icon from "./icons/Icon";
import "./Notiz.css";

/**
 * Kurzer Hinweis im Inhalt: info (blau) oder fehler (rot).
 * @category bausteine
 */
export function Notiz({ art = "info", icon, children }) {
  return (
    <div className={`notiz ${art}`} role={art === "fehler" ? "alert" : undefined}>
      <Icon name={icon || (art === "fehler" ? "x" : "info")} size={18} />
      <span>{children}</span>
    </div>
  );
}

export default Notiz;
